module.exports = __webpack_public_path__ + "static/img/mask_map_bg.1ce8307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask_map_bg.png
// module id = Ad9w
// module chunks = 1